import React, { useCallback, useEffect, useState } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";


import ContentBox from "../../../../../components/ui/ContentBox";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import WhoisRegistrant from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/DomainInfo/WhoisRegistrant";
import AdminContact from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/DomainInfo/AdminContact";
import TechnicalContact from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/AssetDiscovery/DomainInfo/TechnicalContact";

import { formatDate } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getWhoisInformation } from "../../../../../store/actions/scanInfoAction";

const DomainInfo = () => {

    const whoisInformation = useSelector((state) => state.scanInfo?.whoisInformation);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [activeTab, setActiveTab] = useState("whoisRegistrant");
    const [isLoading, setIsLoading] = useState(false);

    const fetchWhoisInfomation = useCallback(()=>{
        let url = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`;
        setIsLoading(true);
        dispatch(getWhoisInformation(url))
    },[dispatch, domainId, scanId, organizationId])

    useEffect(() => {            
        if (triggerStatsFetch) {
            fetchWhoisInfomation()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchWhoisInfomation]);

    useEffect(()=>{
        if(whoisInformation !== null) {
            setIsLoading(false)
        }
    },[whoisInformation])

    return (
        <>
            <div className="scan-info-main-content">
                {
                    whoisInformation?.status === "failed" ?
                    <>
                        <NoDataFound noDataText={whoisInformation.description}/>
                    </>
                    :
                    <>
                        <div className="bg-white-with-shadow content-main-box p-4">
                            <h2 className="content-heading">Domain Registrar</h2>
                            {
                                isLoading ?
                                <SkeletonLoader type={"line"} count={1} currentPage={"domain-info"} />
                                :
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <Row>
                                        <Col lg="3">
                                            <ContentBox label={"Registrar"} value={whoisInformation?.domain_registrar?.name} />
                                        </Col>
                                        <Col lg="3">
                                            <ContentBox label={"Created On"} value={whoisInformation?.domain_registrar?.create_date !== null ? formatDate(whoisInformation?.domain_registrar?.create_date, 'date') : "-"} />
                                        </Col>
                                        <Col lg="3">
                                            <ContentBox label={"Last Updated On"} value={whoisInformation?.domain_registrar?.update_date !== null ? formatDate(whoisInformation?.domain_registrar?.update_date, 'date') : "-"} />
                                        </Col>
                                        <Col lg="3">
                                            <ContentBox label={"Expiry Date"} value={whoisInformation?.domain_registrar?.expiry_date !== null ? formatDate(whoisInformation?.domain_registrar?.expiry_date, 'date') : "-"} />
                                        </Col>
                                    </Row>
                                </motion.div>
                            }                            
                        </div>
                        <div className="bg-white-with-shadow mt-4 p-4">
                            <div className="tab-container d-flex rounded">
                                <p className={`rounded text-center ${activeTab === "whoisRegistrant" ? "active" : ""}`} onClick={()=>{setActiveTab('whoisRegistrant')}}>WHOIS Registrant</p>
                                <p className={`rounded text-center ${activeTab === "adminContact" ? "active" : ""}`} onClick={()=>{setActiveTab('adminContact')}}>Admin Contact</p>
                                <p className={`rounded text-center ${activeTab === "technicalContact" ? "active" : ""}`} onClick={()=>{setActiveTab('technicalContact')}}>Technical Contact</p>
                            </div>
                            {activeTab === "whoisRegistrant" && <WhoisRegistrant registrantData={whoisInformation?.registrant_contact} isLoading={isLoading} />}
                            {activeTab === "adminContact" && <AdminContact registrantData={whoisInformation?.administrative_contact} isLoading={isLoading} />}
                            {activeTab === "technicalContact" && <TechnicalContact registrantData={whoisInformation?.technical_contact} isLoading={isLoading} />}
                        </div>
                    </>
                }                                       
            </div>         
        </>
        
    )
}


export default DomainInfo;